import { AdPicture } from "@app/web-player/ads/ad";
import { useAdPicture } from "./use-ad-picture";
import clsx from "clsx";

interface AdGridItemProps {
  ad: AdPicture;
  className?: string;
  refresh?: number;
  contentFormat?: string;
}
export function AdGridItem({ ad, className, refresh }: AdGridItemProps) {
  const { data } = useAdPicture(ad);

  if (!data) return null;

  return (
    <div
      className={clsx(
        className,
        ad.display === "mobile"
          ? "kads show-on-mobile"
          : "kads show-on-desktop",
      )}
    >
      {data && (
        <a href={data.link} target={data.target || "_blank"}>
          <img src={data.source} className="rounded-panel" />
        </a>
      )}
    </div>
  );
}
